const $doc = $(document);
const $scrollElem = $('.scroll-container');

function disableButtons(value, $scrollElements) {
  const $parent = $scrollElements.closest('.scroll-container-outer');
  if (value == 0) {
    $parent.find('.js-scroll-prev').addClass('disable')
  } else {
    $parent.find('.js-scroll-prev').removeClass('disable')
  }

  if (value == 100) {
    $parent.find('.js-scroll-next').addClass('disable')
  } else {
    $parent.find('.js-scroll-next').removeClass('disable')
  }
}

$scrollElem.mCustomScrollbar({
  axis: 'x',
  autoDraggerLength: false,
  scrollButtons: {
    enable: false
  },
  mouseWheel: {
    enable: false
  },
  callbacks:{
    onScroll:function(){
      disableButtons(this.mcs.leftPct, $(this))
    },
    onInit: function(){
      disableButtons(this.mcs.leftPct, $(this))
    }
  }
});

$doc.on('click', '.js-scroll-prev', function(e) {
  e.preventDefault();
  const $parent = $(this).closest('.scroll-container-outer');
  const $scroll = $parent.find('.scroll-container');
  const scrollItemWidth = $scroll.find('.scroll-item').outerWidth();

  $scroll.mCustomScrollbar("scrollTo",`+=${scrollItemWidth}`);
});

$doc.on('click', '.js-scroll-next', function(e) {
  e.preventDefault();
  const $parent = $(this).closest('.scroll-container-outer');
  const $scroll = $parent.find('.scroll-container');
  const scrollItemWidth = $scroll.find('.scroll-item').outerWidth();

  $scroll.mCustomScrollbar("scrollTo",`-=${scrollItemWidth}`);
});

module.exports = {
  disableButtons
};



// WEBPACK FOOTER //
// ../assets/js/custom-scrollbar.js